import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import pb from '../../lib/pocketbase';
// import './CommercialPresentationPage.css'; // Inline styles used instead

// --- SUB-COMPONENTS ---

const SlideToUnlock = ({ onUnlock }) => {
    // ... code remains same ...
    const [sliderValue, setSliderValue] = useState(0);
    const sliderRef = useRef(null);

    const handleInput = (e) => {
        const val = parseInt(e.target.value);
        setSliderValue(val);
        if (val >= 95) {
            onUnlock();
        }
    };

    const handleEnd = () => {
        if (sliderValue < 95) {
            setSliderValue(0); // Snap back
        }
    };

    return (
        <div className="slide-unlock-container">
            <div className="slide-track">
                <div className="slide-text">Glisser pour démarrer le RDV &nbsp; ➤</div>
                <div
                    className="slide-progress"
                    style={{ width: `calc(5px + (100% - 60px) * ${sliderValue / 100} + 25px)` }}
                ></div>
                {/* Visual Thumb */}
                <div
                    className="slide-thumb"
                    style={{ left: `calc(5px + (100% - 60px) * ${sliderValue / 100})` }}
                >
                    ➔
                </div>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={sliderValue}
                    onChange={handleInput}
                    onTouchEnd={handleEnd}
                    onMouseUp={handleEnd}
                    className="slide-input"
                />
            </div>
        </div>
    );
};

const PortfolioGallery = ({ projects }) => {
    const [index, setIndex] = useState(0);
    const touchStart = useRef(null);
    const touchEnd = useRef(null);

    // Reset index if projects change
    useEffect(() => { setIndex(0); }, [projects]);

    const getImageUrl = (record) => {
        if (!record || !record.cover_image) return 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=500&q=80';
        return pb.files.getUrl(record, record.cover_image, { thumb: '1200x0' });
    };

    const next = () => setIndex(prev => (prev + 1) % projects.length);
    const prev = () => setIndex(prev => (prev - 1 + projects.length) % projects.length);

    // Swipe handlers
    const onTouchStart = (e) => { touchEnd.current = null; touchStart.current = e.targetTouches[0].clientX; };
    const onTouchMove = (e) => { touchEnd.current = e.targetTouches[0].clientX; };
    const onTouchEnd = () => {
        if (!touchStart.current || !touchEnd.current) return;
        const distance = touchStart.current - touchEnd.current;
        const isLeftSwipe = distance > 50;
        const isRightSwipe = distance < -50;
        if (isLeftSwipe) next();
        if (isRightSwipe) prev();
    };

    if (!projects || projects.length === 0) {
        return (
            <div className="pres-section animate-fade-in">
                <h2>Nos Réalisations</h2>
                <div style={{ opacity: 0.5, fontStyle: 'italic', marginTop: 50 }}>Chargement des projets...</div>
            </div>
        );
    }

    const currentProject = projects[index];
    const categoryName = currentProject.expand?.category_id?.name || 'Projet Web';

    return (
        <div className="pres-section animate-fade-in" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <h2 style={{ marginBottom: 20 }}>Nos Réalisations ({index + 1}/{projects.length})</h2>

            <div
                className="slider-container"
                onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}
            >
                <button className="nav-btn prev" onClick={prev}>‹</button>

                <div className="slide-content key-slide">
                    <div className="slide-image-wrapper">
                        <img
                            src={getImageUrl(currentProject)}
                            alt={currentProject.title}
                            className="slide-img"
                        />
                    </div>
                    <div className="slide-info">
                        <div className="slide-cat">{categoryName}</div>
                        <h3>{currentProject.title}</h3>
                        <p>{currentProject.excerpt || "Une réalisation sur mesure signée InfoColab."}</p>
                    </div>
                </div>

                <button className="nav-btn next" onClick={next}>›</button>
            </div>

            <style>{`
                .slider-container { flex: 1; position: relative; display: flex; align-items: center; justify-content: center; width: 100%; overflow: hidden; }
                .nav-btn { background: rgba(255,255,255,0.1); border: none; color: white; font-size: 3rem; padding: 0 20px; cursor: pointer; z-index: 10; border-radius: 50%; height: 60px; width: 60px; display: grid; place-items: center; transition: all 0.2s; }
                .nav-btn:hover { background: rgba(255,255,255,0.3); transform: scale(1.1); }
                
                .slide-content { position: relative; width: 80%; height: 80%; border-radius: 20px; overflow: hidden; background: #1e293b; box-shadow: 0 20px 50px rgba(0,0,0,0.5); display: flex; flexDirection: column; animation: slideIn 0.3s ease-out; }
                .slide-image-wrapper { flex: 2; overflow: hidden; position: relative; }
                .slide-img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s; }
                .slide-content:hover .slide-img { transform: scale(1.05); }
                
                .slide-info { flex: 1; padding: 30px; background: linear-gradient(to top, #0f172a, #1e293b); display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .slide-cat { color: var(--accent); text-transform: uppercase; font-weight: 700; font-size: 0.8rem; letter-spacing: 1px; margin-bottom: 10px; }
                .slide-info h3 { font-size: 2rem; margin: 0 0 10px 0; color: white; }
                .slide-info p { margin: 0; opacity: 0.7; line-height: 1.6; }
                
                @keyframes slideIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
            `}</style>
        </div>
    );
};

const VisualConfigurator = () => {
    const [selectedModules, setSelectedModules] = useState(['base']);

    const MODULES = [
        { id: 'base', name: 'Pack Initial', price: 1500, icon: '🚀', required: true, desc: 'Site Vitrine, Design, Hébergement' },
        { id: 'ecommerce', name: 'E-Commerce', price: 2000, icon: '🛍️', desc: 'Paiement en ligne, Catalogue produits' },
        { id: 'booking', name: 'Réservation', price: 500, icon: '📅', desc: 'Module de prise de RDV / Agenda' },
        { id: 'seo', name: 'Pack SEO', price: 800, icon: '🔍', desc: 'Optimisation Google + Analytics' },
        { id: 'branding', name: 'Identité Visuelle', price: 600, icon: '🎨', desc: 'Logo, Charte graphique complète' },
        { id: 'content', name: 'Rédaction', price: 300, icon: '✍️', desc: 'Contenu pro pour 5 pages' },
    ];

    const toggleModule = (id) => {
        if (id === 'base') return; // Cannot uncheck base
        if (selectedModules.includes(id)) {
            setSelectedModules(selectedModules.filter(m => m !== id));
        } else {
            setSelectedModules([...selectedModules, id]);
        }
    };

    const total = selectedModules.reduce((acc, id) => {
        const mod = MODULES.find(m => m.id === id);
        return acc + (mod ? mod.price : 0);
    }, 0);

    return (
        <div className="pres-section animate-fade-in" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <h2 style={{ marginBottom: 10 }}>Configurateur de Projet</h2>
            <p style={{ opacity: 0.6, marginBottom: 30 }}>Sélectionnez les briques pour construire votre offre sur mesure.</p>

            <div className="config-grid">
                {MODULES.map(mod => {
                    const isSelected = selectedModules.includes(mod.id);
                    return (
                        <div
                            key={mod.id}
                            className={`module-card ${isSelected ? 'selected' : ''} ${mod.required ? 'locked' : ''}`}
                            onClick={() => toggleModule(mod.id)}
                        >
                            <div className="mod-icon">{mod.icon}</div>
                            <div className="mod-info">
                                <div className="mod-header">
                                    <h4>{mod.name}</h4>
                                    {isSelected && <span className="checkmark">✓</span>}
                                </div>
                                <p>{mod.desc}</p>
                            </div>
                            <div className="mod-price">+{mod.price}€</div>
                        </div>
                    );
                })}
            </div>

            <div className="config-footer">
                <div className="total-display">
                    <span className="lbl">Estimation Totale</span>
                    <span className="val">{total.toLocaleString()} €</span>
                </div>
                {/* Future: Button "Generate Quote" */}
            </div>

            <style>{`
                .config-grid { 
                    display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; 
                    padding: 10px; overflow-y: auto; flex: 1;
                }
                .module-card { 
                    background: rgba(255,255,255,0.05); border: 2px solid rgba(255,255,255,0.1); border-radius: 16px; padding: 20px;
                    cursor: pointer; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                    display: flex; align-items: center; gap: 15px; position: relative; overflow: hidden;
                }
                .module-card:hover { background: rgba(255,255,255,0.08); transform: translateY(-2px); }
                
                .module-card.selected { 
                    border-color: var(--accent); background: rgba(var(--accent-rgb), 0.1); 
                    box-shadow: 0 10px 20px -5px rgba(var(--accent-rgb), 0.3);
                }
                .module-card.locked { opacity: 0.8; cursor: default; border-style: dashed; }
                
                .mod-icon { font-size: 2.5rem; }
                .mod-info { flex: 1; text-align: left; }
                .mod-header { display: flex; align-items: center; gap: 10px; }
                .mod-header h4 { margin: 0; font-size: 1.1rem; }
                .checkmark { color: var(--accent); font-weight: 900; }
                .mod-info p { margin: 5px 0 0 0; font-size: 0.8rem; opacity: 0.6; }
                .mod-price { font-weight: 700; color: var(--accent); font-size: 1.1rem; }

                .config-footer {
                    margin-top: 20px; padding: 20px; background: rgba(0,0,0,0.3); border-radius: 16px;
                    display: flex; justify-content: space-between; align-items: center;
                    border: 1px solid rgba(255,255,255,0.1);
                }
                .total-display { display: flex; flex-direction: column; text-align: left; }
                .total-display .lbl { font-size: 0.9rem; text-transform: uppercase; letter-spacing: 1px; opacity: 0.7; }
                .total-display .val { font-size: 2.5rem; font-weight: 800; color: white; line-height: 1; }
            `}</style>
        </div>
    );
};

const OffersView = () => {
    return (
        <div className="pres-section animate-fade-in">
            <h2>Nos Offres</h2>
            <div className="offers-grid">
                <div className="offer-card">
                    <h3>Start</h3>
                    <div className="price">1 490 €</div>
                    <ul>
                        <li>Site One-Page</li>
                        <li>Design Standard</li>
                        <li>Hébergement 1 an</li>
                    </ul>
                </div>
                <div className="offer-card featured">
                    <div className="badge">Populaire</div>
                    <h3>Business</h3>
                    <div className="price">2 990 €</div>
                    <ul>
                        <li>Site 5 Pages</li>
                        <li>Design Personnalisé</li>
                        <li>SEO Basic</li>
                        <li>Formation Admin</li>
                    </ul>
                </div>
                <div className="offer-card">
                    <h3>Elite</h3>
                    <div className="price">Sup. à 5k €</div>
                    <ul>
                        <li>Site Sur Méasure</li>
                        <li>E-Commerce</li>
                        <li>SEO Avancé</li>
                        <li>Maintenance 24/7</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

// --- MAIN PAGE ---

const THEMES = [
    { id: 'indigo', hex: '#4f46e5', rgb: '79, 70, 229' },
    { id: 'rose', hex: '#e11d48', rgb: '225, 29, 72' },
    { id: 'orange', hex: '#ea580c', rgb: '234, 88, 12' },
    { id: 'green', hex: '#16a34a', rgb: '22, 163, 74' },
    { id: 'blue', hex: '#2563eb', rgb: '37, 99, 235' },
    { id: 'purple', hex: '#9333ea', rgb: '147, 51, 234' },
];

export default function CommercialPresentationPage() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [unlocked, setUnlocked] = useState(false);
    const [view, setView] = useState('menu'); // menu, offers, gallery, simulator
    const [time, setTime] = useState(new Date());
    const [realProjects, setRealProjects] = useState([]);
    const [theme, setTheme] = useState(THEMES[0]);

    useEffect(() => {
        const i = setInterval(() => setTime(new Date()), 60000);

        // Fetch Real Projects
        pb.collection('site_realisations').getList(1, 20, {
            sort: '-created',
            filter: 'is_published = true',
            expand: 'category_id'
        })
            .then(res => setRealProjects(res.items))
            .catch(err => {
                console.log("No real projects found, using fallback logic inside component if empty");
            });

        return () => clearInterval(i);
    }, []);

    const handleUnlock = () => {
        setUnlocked(true);
        // Play sound?
    };

    const renderView = () => {
        switch (view) {
            case 'offers': return <OffersView />;
            case 'gallery': return <PortfolioGallery projects={realProjects} />;
            case 'simulator': return <VisualConfigurator />;
            default: return (
                <div className="menu-grid animate-scale-up">
                    <div className="menu-item" onClick={() => setView('offers')}>
                        <span className="icon">🎁</span>
                        <span className="label">Nos Offres</span>
                    </div>
                    <div className="menu-item" onClick={() => setView('gallery')}>
                        <span className="icon">🎨</span>
                        <span className="label">Réalisations</span>
                    </div>
                    <div className="menu-item" onClick={() => setView('simulator')}>
                        <span className="icon">🧮</span>
                        <span className="label">Simulateur</span>
                    </div>
                </div>
            );
        }
    };

    if (!unlocked) {
        return (
            <div className="lock-screen" style={{ backgroundImage: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }}>
                <div className="status-bar">
                    <span>{time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                    <span>🔋 100%</span>
                </div>
                <div className="lock-content">
                    <div className="lock-logo">
                        <span style={{ fontSize: '4rem' }}>⚡</span>
                    </div>
                    <h1>InfoColab<span style={{ color: '#4f46e5' }}>.Present</span></h1>
                    <p>Bienvenue, {user?.firstname || user?.name || user?.email?.split('@')[0] || 'Commercial'}</p>
                </div>
                <div className="unlock-area">
                    <SlideToUnlock onUnlock={handleUnlock} />
                </div>

                <style>{`
                    .lock-screen { position: fixed; inset: 0; color: white; display: flex; flexDirection: column; justify-content: space-between; padding: 40px; font-family: 'Inter', sans-serif; z-index: 9999; }
                    .status-bar { display: flex; justify-content: space-between; opacity: 0.7; font-size: 0.9rem; font-weight: 600; }
                    .lock-content { text-align: center; flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center; }
                    .lock-content h1 { font-size: 3rem; margin: 20px 0 10px; font-weight: 800; letter-spacing: -1px; }
                    .lock-content p { font-size: 1.2rem; opacity: 0.6; font-weight: 300; }
                    
                    /* SLIDER STYLES */
                    .slide-unlock-container { 
                        position: absolute; bottom: 50px; left: 50%; transform: translateX(-50%);
                        width: 90%; max-width: 400px; height: 60px; z-index: 100;
                    }
                    .slide-track { 
                        background: rgba(0,0,0,0.6); 
                        border-radius: 40px; height: 100%; width: 100%;
                        position: relative; 
                        border: 2px solid rgba(255,255,255,0.15); 
                        box-shadow: 0 10px 30px rgba(0,0,0,0.5);
                    }
                    
                    /* Text is now just white with animation */
                    .slide-text { 
                        position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
                        width: 100%; text-align: center; 
                        font-weight: 600; opacity: 1; pointer-events: none; color: white; 
                        animation: pulseText 2s infinite; letter-spacing: 1px; text-transform: uppercase; font-size: 0.9rem; 
                    }
                    
                    .slide-progress { position: absolute; left: 0; top: 0; height: 100%; background: linear-gradient(90deg, rgba(99, 102, 241, 0.2), rgba(99, 102, 241, 0.5)); pointer-events: none; border-radius: 40px; }
                    
                    .slide-thumb { 
                        position: absolute; top: 3px; height: 50px; width: 50px; 
                        background: #6366f1; border-radius: 50%; 
                        color: white; display: grid; place-items: center; font-weight: bold;
                        pointer-events: none; transition: transform 0.05s linear;
                        box-shadow: 0 0 20px rgba(99, 102, 241, 0.8);
                        z-index: 20;
                    }

                    .slide-input { position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: grab; z-index: 30; }
                    
                    @keyframes pulseText { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
                `}</style>
            </div>
        );
    }

    return (
        <div className="presentation-ui" style={{ '--accent': theme.hex, '--accent-rgb': theme.rgb }}>
            {/* TOP BAR */}
            <div className="pres-topbar">
                <div className="back-btn" onClick={() => view === 'menu' ? navigate('/commercial') : setView('menu')}>
                    {view === 'menu' ? '✕ Quitter' : '← Menu'}
                </div>
                <div className="pres-brand">InfoColab<span style={{ color: 'var(--accent)' }}>.Present</span></div>

                {/* Theme Switcher */}
                <div style={{ display: 'flex', gap: 10, marginRight: 20 }}>
                    {THEMES.map(t => (
                        <div
                            key={t.id}
                            onClick={() => setTheme(t)}
                            style={{
                                width: 20, height: 20, borderRadius: '50%', background: t.hex, cursor: 'pointer',
                                border: theme.id === t.id ? '2px solid white' : '2px solid transparent',
                                boxShadow: theme.id === t.id ? `0 0 10px ${t.hex}` : 'none'
                            }}
                        />
                    ))}
                </div>

                <div className="pres-user">{user?.firstname}</div>
            </div>

            {/* CONTENT AREA */}
            <div className="pres-content">
                {renderView()}
            </div>

            <style>{`
                .presentation-ui { position: fixed; inset: 0; background: #0f172a; color: white; display: flex; flex-direction: column; font-family: 'Inter', sans-serif; z-index: 9999; }
                .pres-topbar { height: 60px; display: flex; align-items: center; justify-content: space-between; padding: 0 20px; border-bottom: 1px solid rgba(255,255,255,0.1); background: rgba(15, 23, 42, 0.8); backdrop-filter: blur(10px); }
                .back-btn { cursor: pointer; opacity: 0.7; font-weight: 600; font-size: 0.9rem; }
                .back-btn:hover { opacity: 1; }
                .pres-brand { font-weight: 800; letter-spacing: -0.5px; margin-right: auto; margin-left: 20px; }
                .pres-user { width: 30px; height: 30px; background: var(--accent); border-radius: 50%; display: grid; place-items: center; font-size: 0.8rem; font-weight: 700; }

                .pres-content { flex: 1; padding: 40px; overflow-y: auto; display: flex; justify-content: center; align-items: center; }

                /* MENU GRID */
                .menu-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 30px; width: 100%; max-width: 900px; }
                .menu-item { aspect-ratio: 1; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.1); border-radius: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); }
                .menu-item:hover { transform: translateY(-5px) scale(1.02); background: rgba(255,255,255,0.06); border-color: var(--accent); box-shadow: 0 20px 40px -10px rgba(var(--accent-rgb), 0.3); }
                .menu-item .icon { font-size: 4rem; marginBottom: 20px; }
                .menu-item .label { font-size: 1.5rem; font-weight: 700; }

                /* SECTIONS */
                .pres-section { width: 100%; max-width: 1000px; text-align: center; }
                .pres-section h2 { font-size: 2.5rem; font-weight: 800; margin-bottom: 40px; background: linear-gradient(to right, white, #94a3b8); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
                
                /* OFFERS */
                .offers-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; text-align: left; }
                .offer-card { background: rgba(255,255,255,0.03); border-radius: 20px; padding: 30px; border: 1px solid rgba(255,255,255,0.1); position: relative; }
                .offer-card.featured { background: linear-gradient(135deg, rgba(var(--accent-rgb), 0.1), rgba(var(--accent-rgb), 0.05)); border: 1px solid var(--accent); transform: scale(1.05); z-index: 10; boxShadow: 0 20px 50px -20px rgba(var(--accent-rgb), 0.5); }
                .offer-card h3 { font-size: 1.5rem; margin: 0 0 10px 0; }
                .offer-card .price { font-size: 2rem; font-weight: 800; color: var(--accent); margin-bottom: 20px; }
                .offer-card ul { padding-left: 20px; margin: 0; opacity: 0.8; line-height: 1.8; }
                .offer-card .badge { position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: var(--accent); padding: 4px 12px; borderRadius: 20px; font-size: 0.8rem; font-weight: 700; }


                /* GALLERY */
                .gallery-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 20px; }
                .gallery-card { border-radius: 16px; overflow: hidden; position: relative; aspect-ratio: 16/9; cursor: pointer; group; }
                .gallery-card img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s; background: #333; }
                .gallery-card:hover img { transform: scale(1.1); }
                .gallery-info { position: absolute; bottom: 0; left: 0; width: 100%; padding: 20px; background: linear-gradient(to top, rgba(0,0,0,0.9), transparent); }
                
                /* ANIMATIONS */
                .animate-fade-in { animation: fadeIn 0.5s ease-out; }
                .animate-scale-up { animation: scaleUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes scaleUp { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
            `}</style>
        </div>
    );
}
